// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2lUGF","notes":"Notes_notes__Vd4jI","note":"Notes_note__3t3JZ","markdown":"Notes_markdown__1bcCv"};